import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getErrorMsg } from '../../utils/error-handling';
import { DEFAULT_ROUTE } from '../../types/app-routes';

const REDIRECT_TO_DEFAULT_ROUTE_TIMEOUT = 3000;

@Component({
  selector: 'sma-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less'],
  standalone: true,
})
export class PageNotFoundComponent {
  constructor(router: Router) {
    setTimeout(() => {
      router.navigate([DEFAULT_ROUTE]).catch(getErrorMsg);
    }, REDIRECT_TO_DEFAULT_ROUTE_TIMEOUT);
  }
}
